// extracted by mini-css-extract-plugin
module.exports = {"label":"businessTypesDropdown_label__3Cd9r","select":"businessTypesDropdown_select__ipBXo"};